// Initialize Sesame Section as hidden
document.querySelector('.seasame-section').style.display = 'none';

// Check if geolocation is supported by the browser
if ("geolocation" in navigator) {
    // Prompt user for permission to access their location
    navigator.geolocation.getCurrentPosition(
        // Success callback function
        (position) => {
            // Get the user's latitude and longitude coordinates
            let lat = position.coords.latitude;
            let lng = position.coords.longitude;
            // data = localStorage.getItem('pollen_count');
            // data = data ? data.split('|') : [];
            // lat = data[0].split(':');
            // lat = lat[1] || '';
            
            // lng = data[1].split(':');
            // lng = lng[1] || '';
            // console.log(localStorage)
            console.log(`Latitude: ${lat}, longitude: ${lng}`);

            let pointToCheck = [lat, lng];  // Replace with your actual latitude and longitude
            let boundingBox = [32.0712, -98.06, 33.441, -95.8168];  // Replace with your boundary values

            let isInside = isPointInBoundingBox(pointToCheck, boundingBox);

            if (isInside) {
                console.log('The point is inside the bounding box.');
                // Show the Sesame Section
                showSesameSection();
            } else {
                console.log('The point is outside the bounding box.');
                // Hide the Sesame Section
                hideSesameSection();
            }
        },
        // Error callback function
        (error) => {
            // Handle errors, e.g. user denied location sharing permissions
            console.error("Error getting user location:", error);
            // Hide the Sesame Section in case of error
            hideSesameSection();
        }
    );
} else {
    // Geolocation is not supported by the browser
    console.error("Geolocation is not supported by this browser.");
    // Hide the Sesame Section if geolocation is not supported
    hideSesameSection();
}

function isPointInBoundingBox(point, bounds) {
    let [minLat, minLong, maxLat, maxLong] = bounds;
    let [lat, long] = point;

    return lat >= minLat && lat <= maxLat && long >= minLong && long <= maxLong;
}

function showSesameSection() {
    // Show the Sesame Section by setting display to 'block'
    document.querySelector('.seasame-section').style.display = 'block';
}

function hideSesameSection() {
    // Hide the Sesame Section by setting display to 'none'
    document.querySelector('.seasame-section').style.display = 'none';
}
